import { getValueOfCssVariable, noop } from '@/lib/utils'

import { useTaskFacings } from './todoOverlayData'

// we unfortunately can't use the css vars here because three.js needs actual color values
const ACTION_COLOR: Record<string, string> = {
  REFILL: getValueOfCssVariable('--color-todo-action-refill'),
  CHECK: getValueOfCssVariable('--color-fuchsia-500'),
  REORDER: getValueOfCssVariable('--color-indigo-500'),
  DONE: getValueOfCssVariable('--color-success-500'),
} as const

function Todos() {
  const taskFacings = useTaskFacings()

  if (taskFacings.length === 0) return null

  return (
    <>
      {taskFacings.map(tf => {
        const color = tf.isCompleted ? ACTION_COLOR.DONE : ACTION_COLOR[tf.action]

        return (
          <mesh
            key={tf.facingId}
            position={[tf.geometry.x, tf.geometry.z, tf.geometry.y]}
            quaternion={tf.quaternion}
            castShadow={false}
            receiveShadow={true}
            onClick={noop}
          >
            <boxGeometry args={[tf.geometry.width, tf.geometry.height, 0.01]}/>
            <meshStandardMaterial color={color} />
          </mesh>
        )
      })}
    </>
  )
}

export default Todos